export const formatEtaFromDate = (epochDate: number, inMs: boolean = false): { value: number, text: string } => {
    let now = inMs ? new Date().valueOf() : new Date().valueOf() / 1000;
    let diff: number = now - epochDate;
    let result: { value: number, text: string };
    if (diff < 60) result = { value: null, text: 'shared.justNow' };
    else if (diff < 3600) result = { value: Math.round(diff / 60), text: 'shared.minsAgo' }
    else if (diff < 86400) result = { value: Math.round(diff / 3600), text: 'shared.hoursAgo' }
    else if (diff < 2592000) result = { value: Math.round(diff / 86400), text: 'shared.daysAgo' }
    else result = { value: Math.round(diff / 2592000), text: 'shared.monthsAgo' }
    return result;
}